import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignPopupService } from '../../../services/campaignPopup/campaignPopup.service';

@Component({
  selector: 'app-punch-in',
  templateUrl: './punch-in.component.html',
  styleUrls: ['./punch-in.component.scss'],
})
export class PunchInComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignPopupService: CampaignPopupService
  ) {}

  public ngOnInit(): void {
    setTimeout(() => {
      this.router
        .navigate([this.route.snapshot.queryParams['nextUrl'] || '/default'])
        .then(() => {
          this.campaignPopupService.trigger$.next();
        });
    }, 0);
  }
}
